import { errorValidation } from './utils';

let messagesPhone = $('#messages_phone');

/**
 * Init intlTelInput
 */
[messagesPhone].forEach(phoneInput => {
	phoneInput.inputmask({
		mask: 'V9{1,15}',
		definitions: {
			V: {
				// validator: '^[1-9][0-9]*$',
				validator: '^[0-9]+$',
			},
		},
		placeholder: '',
	});

	// Set the initial country code on page load
	let initialCountryCode = phoneInput.intlTelInput(
		'getSelectedCountryData'
	).dialCode;
	let countryCodeInput = phoneInput
		.closest('.input-wrapper')
		.find('.country-code');
	countryCodeInput.val(initialCountryCode);

	// On blur: validate
	phoneInput.focusout(function () {
		if ($.trim(phoneInput.val())) {
			if (phoneInput.intlTelInput('isValidNumber')) {
				console.log('isValidNumber');
				// Save country code
				countryCodeInput.val(initialCountryCode);
			} else {
				phoneInput.addClass('_error');
			}
		}
	});

	// On keydown: reset
	phoneInput.keydown(function () {
		phoneInput.removeClass('_error');
	});
});

/**
 * Add custom validation method
 */
$.validator.addMethod(
	'validateMessagesPhone',
	function (value, element) {
		return $(element).intlTelInput('isValidNumber');
	},
	window.translations.phoneInvalid
);

/**
 * Validate forms
 */
(() => {
	// Messages
	$("form[name='messages']").validate({
		ignore: [],
		...errorValidation,
		errorClass: 'form__error',
		rules: {
			'messages[name]': {
				required: true,
			},
			'messages[email]': {
				required: true,
				email: true,
			},
			'messages[phone]': {
				required: true,
				// validateMessagesPhone: true,
			},
			'messages[comment]': {
				required: true,
			},
		},
		messages: {
			'messages[name]': {
				required: window.translations.required,
			},
			'messages[email]': {
				required: window.translations.required,
				email: window.translations.emailInvalid,
			},
			'messages[phone]': {
				required: window.translations.required,
			},
			'messages[comment]': {
				required: window.translations.required,
			},
		},
		submitHandler: async (form, e) => {
			if (e) e.preventDefault();

			// Disable submit button
			$(form).find('button[type="submit"]').prop('disabled', true);
			$(form).find('button[type="submit"]').addClass('disabled');

			if (form.hasAttribute('data-recaptcha')) {
				const action = form.getAttribute('data-recaptcha');
				const success = await window.add_recaptcha_token(form, action);

				if (success) {
					console.log('✅ reCAPTCHA token added successfully');
					form.submit();
				} else {
					console.log('❌ reCAPTCHA failed');
				}
			} else {
				console.log('🔄 Form validation passed');
				form.submit();
			}
		},
		success: function (label) {
			let name = label.attr('for');
			label.text('');
		},
	});
})();
